import { Tag } from '@coop/components';
import * as React from 'react';

import useReactRouting from '../../../ecommerce/hooks/useReactRouting';
import { ga4RecipesTracking } from '../../tracking/ga4/recipes';
import BaseRecipeTeaser from '../BaseRecipeTeaser';
import FavoriteRecipeToggle from '../molecules/FavoriteRecipeToggle';
import { RecipeButtonWithFlyIn, useRecipeModal } from '../RecipeModalTrigger';

interface BuyableFoodboxTeaserProps {
    id: string;
    url: string;
    name: string;
    imageUrl: string;
    defaultPortions: number;
    onBuyClick?: (e: React.SyntheticEvent) => void;
    onLinkClick?: (e: React.SyntheticEvent) => void;
    analyticsListName: string;
    withBorder?: boolean;
}

const BuyableFoodboxTeaser = React.forwardRef<HTMLDivElement, BuyableFoodboxTeaserProps>(
    (props, ref) => {
        const { tryOpen, isOpen, close } = useRecipeModal(props.id, props.name);

        const { push } = useReactRouting();

        const track = () => {
            ga4RecipesTracking.click.buyableFoodbox(props.id, props.name);
        };

        const handleImageClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            track();
            push(props.url, true);
            props.onLinkClick?.(e);
        };

        const handleLinkClick = (e: React.SyntheticEvent) => {
            track();
            props.onLinkClick?.(e);
        };

        const handleBuyClick = (e: React.SyntheticEvent) => {
            tryOpen();
            track();
            props.onBuyClick?.(e);
        };

        return (
            <BaseRecipeTeaser.Wrapper
                ref={ref}
                name={props.name}
                imageUrl={props.imageUrl}
                withBorder={props.withBorder}
                topSlot={
                    <FavoriteRecipeToggle
                        recipeName={props.name}
                        recipeId={props.id}
                        type="foodbox"
                    />
                }
                clickableImage
                onImageClick={handleImageClick}
            >
                <BaseRecipeTeaser.Badges>
                    <Tag type="read-only" theme="neutral">
                        Färdigt paket
                    </Tag>
                </BaseRecipeTeaser.Badges>
                <BaseRecipeTeaser.Content>
                    <BaseRecipeTeaser.Info>
                        <BaseRecipeTeaser.Heading
                            as="a"
                            href={props.url}
                            flexOrder={1}
                            onClick={handleLinkClick}
                        >
                            {props.name}
                        </BaseRecipeTeaser.Heading>
                    </BaseRecipeTeaser.Info>
                    <BaseRecipeTeaser.Actions>
                        <RecipeButtonWithFlyIn
                            viewType="both"
                            allowRecipePageRedirect
                            recipeId={props.id}
                            recipeName={props.name}
                            recipeType="foodbox"
                            defaultPortions={props.defaultPortions}
                            onBuyClick={handleBuyClick}
                            onRemoveClick={(e) => e.stopPropagation()}
                            buttonFullWidth
                            buttonSize="default"
                            analyticsListName={props.analyticsListName}
                            isOpen={isOpen}
                            close={close}
                        />
                    </BaseRecipeTeaser.Actions>
                </BaseRecipeTeaser.Content>
            </BaseRecipeTeaser.Wrapper>
        );
    },
);

export default BuyableFoodboxTeaser;
